import React from 'react';
export function Materials() {
  return <section id="materials" className="py-20 bg-primary text-white" data-id="element-320">
      <div className="container mx-auto px-4 md:px-6" data-id="element-321">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-322">
          <div data-id="element-323">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-324">
              Medical-Grade Material Expertise
            </h2>
            <p className="text-blue-100 text-lg mb-8 leading-relaxed" data-id="element-325">
              Selecting the right resin is critical for medical devices and
              packaging. We have extensive experience processing
              engineering-grade thermoplastics suitable for healthcare
              applications.
            </p>
            <div className="grid grid-cols-2 gap-6" data-id="element-326">
              <div data-id="element-327">
                <h4 className="font-bold text-white mb-2" data-id="element-328">Commodity Resins</h4>
                <ul className="text-blue-200 space-y-1 text-sm" data-id="element-329">
                  <li data-id="element-330">Polypropylene (PP)</li>
                  <li data-id="element-331">Polyethylene (PE)</li>
                  <li data-id="element-332">Polystyrene (PS)</li>
                </ul>
              </div>
              <div data-id="element-333">
                <h4 className="font-bold text-white mb-2" data-id="element-334">
                  Engineering Resins
                </h4>
                <ul className="text-blue-200 space-y-1 text-sm" data-id="element-335">
                  <li data-id="element-336">Polycarbonate (PC)</li>
                  <li data-id="element-337">ABS</li>
                  <li data-id="element-338">Nylon (PA)</li>
                  <li data-id="element-339">TPE / TPU</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="relative" data-id="element-340">
            <div className="absolute inset-0 bg-accent/20 rounded-2xl transform rotate-3" data-id="element-341"></div>
            <div className="relative bg-white/10 backdrop-blur-sm border border-white/20 p-8 rounded-2xl" data-id="element-342">
              <h3 className="text-xl font-bold mb-4" data-id="element-343">
                Material Selection Support
              </h3>
              <p className="text-blue-100 mb-6" data-id="element-344">
                Not sure which material is best for your application? We provide
                guidance on:
              </p>
              <ul className="space-y-3" data-id="element-345">
                {['Chemical resistance requirements', 'Sterilization compatibility (Gamma, EtO, Autoclave)', 'FDA compliance & USP Class VI certification', 'Impact strength and flexibility'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-346">
                    <div className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-347"></div>
                    <span className="text-sm md:text-base" data-id="element-348">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}